import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 17,
	viewBox: "0 0 12 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 1.5C0 0.6875 0.65625 0 1.5 0V1.5V13.8125L5.5625 10.9062C5.8125 10.7188 6.15625 10.7188 6.4375 10.9062L10.5 13.8125V1.5H1.5V0H10.5C11.3125 0 12 0.6875 12 1.5V15.25C12 15.5312 11.8438 15.8125 11.5938 15.9375C11.3438 16.0625 11.0312 16.0312 10.8125 15.875L6 12.4375L1.15625 15.875C0.9375 16.0312 0.65625 16.0625 0.40625 15.9375C0.15625 15.8125 0 15.5312 0 15.25V1.5Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgBookmark);
export { ForwardRef as ReactComponent };
